import { defineStore } from "pinia";
import { ref, computed } from "vue";

function mostRecentFirst(a, b) {
  return Date.parse(a.date) - Date.parse(b.date);
}

export const useResultsStore = defineStore("results", () => {
  const bloodResults = ref([]);

  function reset() {
    bloodResults.value = [];
  }

  async function setBloodResults(patient) {
    const results = patient.tests.map((t) => t.result).filter(Boolean);
    bloodResults.value = results;
  }

  const bloodResultsMostRecentFirst = computed(() => {
    return [...bloodResults.value].sort(mostRecentFirst);
  });

  const latestBloodResult = computed(() => {
    const [latest] = bloodResultsMostRecentFirst.value;
    return latest;
  });

  function getBloodResultById(id) {
    return bloodResults.value.find((results) => results.id === id);
  }

  return {
    setBloodResults,
    bloodResultsMostRecentFirst,
    bloodResults,
    latestBloodResult,
    getBloodResultById,
    reset,
  };
}, { persist: true });

export function getLowestRangeForPanel(panel) {
  const stages = panel.markers.map((marker) => marker?.resultRangeStage?.name);
  if (stages.includes("rangeLow") || stages.includes("rangeHigh")) {
    return "rangeLow";
  }
  if (stages.includes("rangeLowNormal") || stages.includes("rangeHighNormal")) {
    return "rangeLowNormal";
  }
  return "rangeNormal";
}
